import { render, staticRenderFns } from "./LeafletMarker.vue?vue&type=template&id=2654091f&"
import script from "./LeafletMarker.vue?vue&type=script&lang=js&"
export * from "./LeafletMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports